import { readAuthStorage } from './authStorage';

function currentUser() {
  try { return JSON.parse(readAuthStorage('odoo_user') || 'null'); } catch { return null; }
}
const keyFor = user => user?.uid ? `last-project:${user.uid}` : null;

export function rememberProject(project, user = currentUser()) {
  const key = keyFor(user);
  if (key) localStorage.setItem(key, JSON.stringify({ id: project.id, name: project.name || '' }));
  localStorage.setItem('selected_project_id', String(project.id));
  localStorage.setItem('selected_project_name', project.name || '');
  window.dispatchEvent(new Event('active-project-change'));
}

export function restoreProject(user, allowLegacy = false) {
  const key = keyFor(user);
  let saved;
  try { saved = key && JSON.parse(localStorage.getItem(key) || 'null'); } catch { saved = null; }
  if (saved?.id) rememberProject(saved, user);
  else if (allowLegacy && localStorage.getItem('selected_project_id')) {
    rememberProject({id:Number(localStorage.getItem('selected_project_id')),name:localStorage.getItem('selected_project_name')},user);
  } else {
    localStorage.removeItem('selected_project_id');
    localStorage.removeItem('selected_project_name');
  }
}
